import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import { ItemCountOperation } from './types.js';

const QuantitySelector = (props)=>{
    const [amountArithmeticOperation, setAmountArithmeticOperation] = React.useState(undefined);
    const [key, setKey] = React.useState('');
    const { quantity , onDecreaseQuantity , onIncreaseQuantity , minimumQuantity =1 , maximumQuantity , isDisabled =false , disableAnimation =false ,  } = props;
    const { getLabel  } = useIntl();
    const handleQuantityChange = (operation, onChange)=>{
        onChange();
        setAmountArithmeticOperation(operation);
        setKey(crypto.randomUUID());
    };
    const decreaseQuantity = ()=>{
        handleQuantityChange(ItemCountOperation.DECREASE, onDecreaseQuantity);
    };
    const increaseQuantity = ()=>{
        handleQuantityChange(ItemCountOperation.INCREASE, onIncreaseQuantity);
    };
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({
        className: "quantity-selector",
        "data-t": props['data-t'],
        role: "spinbutton",
        "aria-valuenow": quantity
    }, minimumQuantity && {
        'aria-valuemin': minimumQuantity
    }, maximumQuantity && {
        'aria-valuemax': maximumQuantity
    }, {
        "aria-label": getLabel('products.solutions.selectAmount')
    }), /*#__PURE__*/ React.createElement("button", {
        "aria-label": getLabel('cart.item.quantity.decrement'),
        className: "quantity-selector__button quantity-selector__button--minus",
        disabled: quantity === minimumQuantity || isDisabled,
        onClick: decreaseQuantity,
        type: "button"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "minus",
        width: 18,
        height: 18
    })), /*#__PURE__*/ React.createElement(Text, {
        key: key,
        variant: "caption",
        component: "span",
        className: classnames('quantity-selector__amount', {
            [`quantity-selector__amount--${amountArithmeticOperation}`]: amountArithmeticOperation,
            'quantity-selector__amount--disable-animation': disableAnimation
        })
    }, quantity), /*#__PURE__*/ React.createElement("button", {
        "aria-label": getLabel('cart.item.quantity.increment'),
        className: "quantity-selector__button quantity-selector__button--plus",
        disabled: maximumQuantity && quantity >= maximumQuantity || isDisabled,
        onClick: increaseQuantity,
        type: "button"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "plus",
        width: 18,
        height: 18
    })));
};

export { QuantitySelector as default };
//# sourceMappingURL=QuantitySelector.js.map
